// extracted by mini-css-extract-plugin
module.exports = {"root":"_90b70f9","lateReg":"_19691f5","countdown":"_974fc86"};